import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Divider, Grid, Stack, Typography } from '@mui/material';

import { hasSupervisorFeatureFlag } from '@paragon/login-tools';
import { sortBy } from '@paragon/utilities';

import { showCreateDirectoryDialog, showCreateLineDialog } from '../../actions/dialogActions';
import { getHolisticViewModel, LineViewModel } from '../../selectors/holisticViewModelSelector';
import { useAppDispatch, useAppSelector } from '../hooks';
import { HierarchicalViewModelCard } from '../interface/cards/HierarchicalViewModelCard';
import { ResponsiveButtonBar } from '../interface/ResponsiveButtonBar';

export function LinesPage() {
  const dispatch = useAppDispatch();
  const viewModel = useAppSelector(getHolisticViewModel);
  const isSupervisor = useAppSelector(hasSupervisorFeatureFlag);

  if (viewModel === 'loading' || viewModel === 'error') return null;

  const directoryCards = sortBy(
    Object.entries(viewModel.hierarchicalView.children.directories),
    ([_, model]) => model.source.name,
  ).map(([guid, model]) => (
    <Grid size={{ xs: 12, md: 6 }} key={guid}>
      <HierarchicalViewModelCard model={model} />
    </Grid>
  ));

  const lineModels = Object.values(viewModel.flatView).filter((model) => model.type === 'line') as LineViewModel[];
  const allLineCards = sortBy(lineModels, (model) => model.source.name).map((model) => (
    <Grid size={{ xs: 12, md: 6 }} key={(model as LineViewModel).source.guid}>
      <HierarchicalViewModelCard model={model} />
    </Grid>
  ));

  return (
    <Stack>
      <Stack direction="row" sx={{ alignItems: 'center' }}>
        <Typography variant="h3" gutterBottom sx={{ marginRight: 'auto' }}>
          All lines
        </Typography>

        {isSupervisor && (
          <ResponsiveButtonBar
            breakpoint="sm"
            icon={<AddIcon />}
            actions={[
              ['Create Directory', () => void dispatch(showCreateDirectoryDialog())],
              ['Create Line', () => void dispatch(showCreateLineDialog())],
            ]}
          />
        )}
      </Stack>

      <Grid container sx={{ alignItems: 'stretch' }} spacing={1}>
        {directoryCards}
      </Grid>

      {directoryCards.length > 0 && <Divider sx={{ marginY: 2 }} />}

      <Grid container sx={{ alignItems: 'stretch' }} spacing={1}>
        {allLineCards}
      </Grid>
    </Stack>
  );
}
